import { Module } from './module.types';
import { SocialLink } from './socials.types';
import { TranslateString } from './translation.types';

export interface Speaker extends Module {
  speaker: number;
  first_name: string;
  last_name: string;
  description: TranslateString;
  image: string;
  original_image: string;
  link_social: boolean;
  social_links?: SocialLink[]; // related_sessions should be in the content component of the page_module because they do not reach across events
  attributes?: SpeakerAttribute[];
  job_title: TranslateString;
  attributes_enabled: boolean;
  misc_translations?: ISpeakerMiscTranslations;
  location?: string | null;
  email?: string | null;
  invite_status?: ESpeakerInviteStatus | null;
  // New parameters must be optional or nullable
}

export interface CreateSpeaker {
  first_name: string;
  last_name: string;
  description: TranslateString;
  image: string;
  original_image: string;
  link_social: boolean;
  social_links?: SocialLink[];
  attributes?: SpeakerAttribute[];
  job_title: TranslateString;
  attributes_enabled: boolean;
  misc_translations?: ISpeakerMiscTranslations;
  location?: string | null;
  email?: string | null;
  invite_status?: ESpeakerInviteStatus | null;
  // New parameters must be optional or nullable
}

export interface SpeakerAttribute {
  icon: string;
  attribute: TranslateString;
  value: TranslateString;
  // New parameters must be optional or nullable
}

export interface ISpeakerMiscTranslations {
  [key: string]: TranslateString;
}

export enum ESpeakerInviteStatus {
  pending = 'pending',
  confirmed = 'confirmed',
  rejected = 'rejected',
}
